import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-file",
  "use": "icon-file-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol viewBox=\"0 0 17 17\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-file\"><path d=\"M9.51 2.281l3.75 3.75v7.266c0 .312-.117.586-.352.82a1.124 1.124 0 0 1-.82.352H5.057a1.12 1.12 0 0 1-.82-.352 1.124 1.124 0 0 1-.352-.82V3.453c0-.312.117-.586.351-.82.235-.235.508-.352.82-.352H9.51zM9.04 6.5h3.281l-3.28-3.281V6.5z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol